<div class="card">
  <app-header titulo="Configuração de Balanças" descricao="Gerencie as balanças cadastradas e configure os vínculos de tipo produto."></app-header>

  <p-tabView styleClass="mt-3">

    <!-- ========================= TAB: BALANÇAS ========================= -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2">
          <i class="pi pi-sliders-h"></i>
          <span>Balanças</span>
        </div>
      </ng-template>

      <div class="flex align-items-center justify-content-between mb-3">
        <span class="text-900 font-semibold text-lg">Balanças Cadastradas</span>
        <p-button label="Nova Balança" icon="pi pi-plus" severity="success" size="small"
          (onClick)="abrirNovo()">
        </p-button>
      </div>

      <p-table #dtbalanca [value]="balancas" [loading]="loading" [globalFilterFields]="['modelo', 'descricao', 'ip_balanca', 'canal', 'instancia']" dataKey="id" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [rowsPerPageOptions]="[10, 20, 50]" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros" [scrollable]="true" scrollHeight="40.5rem" [resizableColumns]="true" frozenWidth="90px">
        <ng-template pTemplate="caption">
          <div class="flex align-items-center justify-content-between gap-2">
            <span class="text-900 font-semibold">{{ balancas.length }} Registros</span>
            <div class="flex align-items-center gap-2">
              <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text" (input)="dtbalanca.filterGlobal($any($event.target)?.value, 'contains')" placeholder="Pesquisar..." />
              </span>
              <p-button icon="pi pi-refresh" [rounded]="true" [text]="true" severity="secondary" (onClick)="carregarBalancas()" [loading]="loading" pTooltip="Atualizar" tooltipPosition="top"></p-button>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="instancia" style="min-width: 120px;">
              Instância <p-sortIcon field="instancia"></p-sortIcon>
              <p-columnFilter field="instancia" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" [showApplyButton]="false" [showClearButton]="false">
                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                  <p-multiSelect [ngModel]="value" [options]="opcoesInstanciaBalanca" (onChange)="filter($event.value)" placeholder="Selecionar..." [showClear]="true" [filter]="true" [style]="{'min-width': '14rem'}"></p-multiSelect>
                </ng-template>
              </p-columnFilter>
            </th>
            <th pSortableColumn="modelo" style="min-width: 140px;">Modelo <p-sortIcon field="modelo"></p-sortIcon></th>
            <th pSortableColumn="descricao" style="min-width: 180px;">Descrição <p-sortIcon field="descricao"></p-sortIcon></th>
            <th pSortableColumn="canal" style="min-width: 90px;">Canal <p-sortIcon field="canal"></p-sortIcon></th>
            <th pSortableColumn="ip_balanca" style="min-width: 150px;">IP Balança <p-sortIcon field="ip_balanca"></p-sortIcon></th>
            <th pSortableColumn="porta_balanca" style="min-width: 90px;">Porta <p-sortIcon field="porta_balanca"></p-sortIcon></th>
            <th pSortableColumn="permite_digitacao_manual" style="min-width: 130px;">Digitação Manual <p-sortIcon field="permite_digitacao_manual"></p-sortIcon></th>
            <th pFrozenColumn alignFrozen="right" style="min-width: 90px; text-align: center;">Ações</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-balanca>
          <tr>
            <td><p-tag *ngIf="balanca.instancia" [value]="balanca.instancia" severity="secondary" [rounded]="true" styleClass="text-xs"></p-tag><span *ngIf="!balanca.instancia" class="text-400">—</span></td>
            <td><span class="font-semibold text-900">{{ balanca.modelo }}</span></td>
            <td><span class="text-700">{{ balanca.descricao || '—' }}</span></td>
            <td>
              <p-tag *ngIf="balanca.canal" [value]="balanca.canal" severity="info" [rounded]="true" styleClass="text-xs"></p-tag>
              <span *ngIf="!balanca.canal" class="text-400">—</span>
            </td>
            <td><code class="text-sm surface-ground border-round px-2 py-1">{{ balanca.ip_balanca }}</code></td>
            <td><code class="text-sm surface-ground border-round px-2 py-1">{{ balanca.porta_balanca }}</code></td>
            <td>
              <p-tag *ngIf="balanca.permite_digitacao_manual" value="Permitida" severity="success" [rounded]="true" styleClass="text-xs"></p-tag>
              <p-tag *ngIf="!balanca.permite_digitacao_manual" value="Não permitida" severity="secondary" [rounded]="true" styleClass="text-xs"></p-tag>
            </td>
            <td pFrozenColumn alignFrozen="right" style="text-align: center;">
              <p-button icon="pi pi-pencil" [rounded]="true" [text]="true" severity="info" (onClick)="abrirEditar(balanca)" pTooltip="Editar" tooltipPosition="top"></p-button>
              <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger" (onClick)="confirmarExclusao(balanca, $event)" pTooltip="Excluir" tooltipPosition="top"></p-button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="8">
              <div class="flex flex-column align-items-center justify-content-center py-5">
                <i class="pi pi-inbox text-4xl text-300 mb-3"></i>
                <span class="text-500 font-medium">Nenhuma balança cadastrada.</span>
                <span class="text-400 text-sm mt-1">Clique em "Nova Balança" para começar.</span>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>

    <!-- ========================= TAB: TIPO PRODUTO ========================= -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2">
          <i class="pi pi-box"></i>
          <span>Tipo Produto</span>
        </div>
      </ng-template>

      <div class="flex align-items-center justify-content-between mb-3">
        <span class="text-900 font-semibold text-lg">Vínculos de Tipo Produto</span>
        <p-button label="Novo Vínculo" icon="pi pi-plus" severity="success" size="small" (onClick)="abrirNovoProduto()"></p-button>
      </div>

      <p-table [value]="produtos" [loading]="loadingProdutos" dataKey="id" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [rowsPerPageOptions]="[10, 20, 50]" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros" [scrollable]="true" scrollHeight="40.5rem">
        <ng-template pTemplate="caption">
          <div class="flex align-items-center justify-content-between">
            <span class="text-900 font-semibold">{{ produtos.length }} Registros</span>
            <p-button icon="pi pi-refresh" [rounded]="true" [text]="true" severity="secondary" (onClick)="carregarProdutos()" [loading]="loadingProdutos" pTooltip="Atualizar" tooltipPosition="top"></p-button>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th style="min-width: 120px;">
              Instância
              <p-columnFilter field="instancia" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" [showApplyButton]="false" [showClearButton]="false">
                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                  <p-multiSelect [ngModel]="value" [options]="opcoesInstanciaProduto" (onChange)="filter($event.value)" placeholder="Selecionar..." [showClear]="true" [filter]="true" [style]="{'min-width': '14rem'}"></p-multiSelect>
                </ng-template>
              </p-columnFilter>
            </th>
            <th style="min-width: 130px;">Tipo Produto</th>
            <th style="min-width: 200px;">Balança Entrada</th>
            <th style="min-width: 200px;">Balança Saída</th>
            <th pFrozenColumn alignFrozen="right" style="min-width: 90px; text-align: center;">Ações</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-produto>
          <tr>
            <td><p-tag *ngIf="produto.instancia" [value]="produto.instancia" severity="secondary" [rounded]="true" styleClass="text-xs font-bold"></p-tag><span *ngIf="!produto.instancia" class="text-400">—</span></td>
            <td><p-tag [value]="produto.codigo" severity="info" [rounded]="true" styleClass="text-xs font-bold"></p-tag></td>
            <td>
              <span *ngIf="produto.balanca_entrada_id" class="font-medium text-900">{{ getNomeBalanca(produto.balanca_entrada_id) }}</span>
              <span *ngIf="!produto.balanca_entrada_id" class="text-400">—</span>
            </td>
            <td>
              <span *ngIf="produto.balanca_saida_id" class="font-medium text-900">{{ getNomeBalanca(produto.balanca_saida_id) }}</span>
              <span *ngIf="!produto.balanca_saida_id" class="text-400">—</span>
            </td>
            <td pFrozenColumn alignFrozen="right" style="text-align: center;">
              <p-button icon="pi pi-pencil" [rounded]="true" [text]="true" severity="info" (onClick)="abrirEditarProduto(produto)" pTooltip="Editar vínculo" tooltipPosition="top"></p-button>
              <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger" (onClick)="confirmarExclusaoProduto(produto, $event)" pTooltip="Excluir vínculo" tooltipPosition="top"></p-button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5">
              <div class="flex flex-column align-items-center justify-content-center py-5">
                <i class="pi pi-inbox text-4xl text-300 mb-3"></i>
                <span class="text-500 font-medium">Nenhum vínculo cadastrado.</span>
                <span class="text-400 text-sm mt-1">Clique em "Novo Vínculo" para associar um produto a uma balança.</span>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>

  </p-tabView>
</div>

<!-- ========================= DIALOG: BALANÇA ========================= -->
<p-dialog [header]="editando ? 'Editar Balança' : 'Nova Balança'" [(visible)]="displayDialog" [modal]="true" [style]="{ width: '560px' }" [closable]="true" (onHide)="fecharDialog()">
  <div class="grid p-fluid mt-1">
    <div class="col-12 field">
      <label class="font-medium text-800">Instância <span *ngIf="!editando" class="text-red-500">*</span></label>
      <app-empresa-dropdown *ngIf="!editando" modo="unico" [(selecionadas)]="balancaSelecionada.instancia!"></app-empresa-dropdown>
      <input *ngIf="editando" pInputText [value]="balancaSelecionada.instancia" [disabled]="true" class="w-full" />
    </div>
    <div class="col-12 md:col-6 field">
      <label class="font-medium text-800">Modelo <span class="text-red-500">*</span></label>
      <input pInputText type="text" [(ngModel)]="balancaSelecionada.modelo" placeholder="Ex: Toledo Prix 3" />
    </div>
    <div class="col-12 md:col-6 field">
      <label class="font-medium text-800">Canal</label>
      <input pInputText type="text" [(ngModel)]="balancaSelecionada.canal" placeholder="Ex: COM1" />
    </div>
    <div class="col-12 field">
      <label class="font-medium text-800">Descrição</label>
      <textarea pInputTextarea [rows]="2" [(ngModel)]="balancaSelecionada.descricao" placeholder="Descrição breve da balança..."></textarea>
    </div>
    <div class="col-12 md:col-8 field">
      <label class="font-medium text-800">IP da Balança <span class="text-red-500">*</span></label>
      <input pInputText type="text" [(ngModel)]="balancaSelecionada.ip_balanca" placeholder="Ex: 192.168.1.100" />
    </div>
    <div class="col-12 md:col-4 field">
      <label class="font-medium text-800">Porta <span class="text-red-500">*</span></label>
      <p-inputNumber [(ngModel)]="balancaSelecionada.porta_balanca" [useGrouping]="false" placeholder="9100" [min]="1" [max]="65535"></p-inputNumber>
    </div>
    <div class="col-12 field">
      <p-checkbox [(ngModel)]="balancaSelecionada.permite_digitacao_manual" [binary]="true" label="Permite digitação manual do peso" inputId="permiteDigitacaoManual"></p-checkbox>
      <small class="block text-500 mt-1">Quando ativado, o usuário poderá digitar o peso manualmente na tela de pesagem para remessas vinculadas a esta balança, em vez de apenas capturar da balança.</small>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <p-button label="Cancelar" icon="pi pi-times" severity="secondary" [outlined]="true" (onClick)="fecharDialog()"></p-button>
      <p-button label="Salvar" icon="pi pi-check" (onClick)="salvar()" [loading]="loadingSalvar"></p-button>
    </div>
  </ng-template>
</p-dialog>

<!-- ========================= DIALOG: TIPO PRODUTO ========================= -->
<p-dialog [header]="editandoProduto ? 'Editar Vínculo de Produto' : 'Novo Vínculo de Produto'" [(visible)]="displayProdutoDialog" [modal]="true" [style]="{ width: '500px' }" [closable]="true" (onHide)="fecharProdutoDialog()">
  <div class="grid p-fluid mt-1">
    <div class="col-12 field">
      <label class="font-medium text-800">Instância <span *ngIf="!editandoProduto" class="text-red-500">*</span></label>
      <app-empresa-dropdown *ngIf="!editandoProduto" modo="unico" [(selecionadas)]="produtoSelecionado.instancia!"></app-empresa-dropdown>
      <input *ngIf="editandoProduto" pInputText [value]="produtoSelecionado.instancia" [disabled]="true" class="w-full" />
    </div>
    <div class="col-12 field">
      <label class="font-medium text-800">Tipo Produto <span class="text-red-500">*</span></label>
      <p-dropdown [options]="tiposProduto" [(ngModel)]="produtoSelecionado.codigo" placeholder="Selecione o tipo de produto" appendTo="body" [disabled]="editandoProduto"></p-dropdown>
    </div>
    <div class="col-12 field">
      <label class="font-medium text-800">Balança de Entrada</label>
      <p-dropdown [options]="balancasDoProduto" [(ngModel)]="produtoSelecionado.balanca_entrada_id" optionLabel="modelo" optionValue="id" placeholder="Selecione a balança de entrada" [filter]="true" filterPlaceholder="Buscar..." [showClear]="true" appendTo="body" emptyMessage="Nenhuma balança disponível">
        <ng-template let-b pTemplate="item">
          <span>{{ b.modelo }} <small class="text-400 ml-1">{{ b.ip_balanca }}</small></span>
        </ng-template>
      </p-dropdown>
    </div>
    <div class="col-12 field">
      <label class="font-medium text-800">Balança de Saída</label>
      <p-dropdown [options]="balancasDoProduto" [(ngModel)]="produtoSelecionado.balanca_saida_id" optionLabel="modelo" optionValue="id" placeholder="Selecione a balança de saída" [filter]="true" filterPlaceholder="Buscar..." [showClear]="true" appendTo="body" emptyMessage="Nenhuma balança disponível">
        <ng-template let-b pTemplate="item">
          <span>{{ b.modelo }} <small class="text-400 ml-1">{{ b.ip_balanca }}</small></span>
        </ng-template>
      </p-dropdown>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <p-button label="Cancelar" icon="pi pi-times" severity="secondary" [outlined]="true" (onClick)="fecharProdutoDialog()"></p-button>
      <p-button label="Salvar" icon="pi pi-check" (onClick)="salvarProduto()" [loading]="loadingSalvarProduto"></p-button>
    </div>
  </ng-template>
</p-dialog>

<p-confirmDialog styleClass="border-round-xl"></p-confirmDialog>
